<template>
    <section>
        <div class="row">
            <div class="col p-5">
                <router-view></router-view>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "AccountIndex",
        mounted() {
            document.title = 'Profile - ' + process.env.APP_NAME;
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/account/Index.vue